import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TuiButtonOptions, TuiSizeS } from '@taiga-ui/core';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownButtonComponent {
  @Input() label = '';
  @Input() icon?: string;
  @Input() size: TuiSizeS = 'm';
  @Input() appearance: TuiButtonOptions['appearance'] = 'primary';
  @Input() onlyIcon = false;

  isDropdownOpened = false;
}
